module.exports = __webpack_public_path__ + "static/media/survey-man.afd0ad27.svg";